/* Home.jsx */
import React, {useEffect} from 'react'
// Components
import Header from '../Components/Header'
import Card from '../Components/Card'
// CSS
import styled from 'styled-components'
// FB
import { loadMemeFB } from "../Redux/modules/words";
import {useDispatch} from "react-redux";

const Home = () => {
  const onPage = true;

  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(loadMemeFB());
  })
  
  return (
      <>
    <Header onPage={onPage} />
        <Wrap>
            <Card />
        </Wrap>
      </>
  )
}

export default Home
const Wrap = styled.div`
  // 그리드
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr ;
  gap: 50px;
  margin: 50px 30px 0px 30px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr ;
  }
  @media screen and (max-width: 700px) {
    grid-template-columns: 1fr  ;
  }
`;

